import InfoIcon from '@assets/icons/info.svg'
import XIcon from '@assets/icons/x.svg'
import { useTooltipStore } from '@store/common/useTooltipStore.js'
import { memo, useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'

export const Tooltip = memo(({ tooltipKey }) => {
  const { t } = useTranslation()
  const activeKey = useTooltipStore((s) => s.activeKey)
  const onToggle = useTooltipStore((s) => s.onToggle)
  const onClose = useTooltipStore((s) => s.onClose)

  const ref = useRef(null)
  const isOpen = activeKey === tooltipKey
  const title = tooltipKey ? t(`tooltip.${tooltipKey}.title`, { defaultValue: '' }) : ''

  const content = tooltipKey ? t(`tooltip.${tooltipKey}.content`, { defaultValue: '' }) : ''

  useEffect(() => {
    const handleOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        onClose?.()
      }
    }
    document.addEventListener('mousedown', handleOutside)
    document.addEventListener('touchstart', handleOutside)

    return () => {
      document.removeEventListener('mousedown', handleOutside)
      document.removeEventListener('touchstart', handleOutside)
    }
  }, [])

  return (
    <div className="inline-block">
      <img
        src={InfoIcon}
        alt={t('common.tooltipAlt')}
        width={13}
        className={'relative -top-[0.5px]'}
        onClick={() => onToggle(tooltipKey)}
      />
      {isOpen && (
        <div
          className="text-14 text-navy-900 tooltip-inner absolute left-1/2 z-10 mt-2 w-2/3 min-w-[295px] -translate-x-1/2 rounded bg-white px-16 py-24 leading-5"
          ref={ref}
        >
          <div className={'mb-8 flex items-center justify-between'}>
            <strong>{title}</strong>
            <img
              src={XIcon}
              alt={t('common.close')}
              width={10}
              onClick={onClose}
              decoding="async"
            />
          </div>
          <p>{content}</p>
        </div>
      )}
    </div>
  )
})
